import React, { forwardRef, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { IStyled } from '../../../styles/types';
import { SvgIcon } from '../../Icon';
import { theme } from '../../../styles/theme';

interface IProps extends IStyled {
  children: ReactNode;
  isAlwaysActive?: boolean;
  isInteractive?: boolean;
  isDisabled?: boolean;
  hideCaret?: boolean;
}

const Label = styled.div<{
  $isAlwaysActive?: boolean;
  $isInteractive?: boolean;
  $isDisabled?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  ${({ $isAlwaysActive }) =>
    $isAlwaysActive &&
    css`
      font-weight: 500;
      color: ${theme.colors.mainBlue};
      cursor: pointer;
    `}
  ${({ $isInteractive }) =>
    $isInteractive &&
    css`
      &:hover,
      [aria-expanded='true'] &,
      &[aria-expanded='true'] {
        color: ${theme.colors.mainBlue};
        cursor: pointer;
      }
    `}
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
    `}
`;
const StyledCaretIcon = styled(SvgIcon)`
  width: 16px;
`;

const SingleSelectLabel = forwardRef<HTMLDivElement, IProps>(
  (
    {
      children,
      hideCaret,
      isAlwaysActive,
      isInteractive,
      isDisabled,
      className,
      ...props
    },
    ref,
  ) => (
    <Label
      ref={ref}
      className={className}
      {...props}
      $isAlwaysActive={isAlwaysActive}
      $isInteractive={isInteractive}
      $isDisabled={isDisabled}
    >
      {children}
      {!hideCaret && (
        <StyledCaretIcon
          name="caret-down-fill"
          width={10}
          height={10}
          customFill="currentColor"
        />
      )}
    </Label>
  ),
);

export default SingleSelectLabel;
